module.exports = __webpack_public_path__ + "img/fd25d0d2bb30f8934a7565325ba3a366.png";